import React from 'react'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'

export const SeparatorSettings = () => {
  return (
    <ToolbarSection title="Style" />
  )
}
